/* eslint-disable prefer-rest-params */
const  xhr = XMLHttpRequest
const  send = xhr.prototype.send
const  stackStart: any[] = []
const  stackStop: any[] = []
const  stackError: any[] = []

/**
 * how many callbacks are registered
 */
let highJackCount = 0

interface Options {
  /**
   * Runs when AJAX is started
   */
  start: () => void
  /**
   * Runs when AJAX is finished
   */
  stop: () => void
  /**
   * Runs when AJAX run into a error
   */
  error: () => void
}

/**
 * Register a callback that will be called when start & end AJAX request
 */
export function highJackAjax({start, stop, error}: Options) {
  stackStart.push(start)
  stackStop.push(stop)
  stackError.push(error)

  highJackCount += 1

  if(highJackCount > 1) {
    return
  }

  function endHandler() {
    stackStop.forEach((fn) => {
      fn()
    })
  }

  function errorHandler() {
    stackError.forEach((fn) => {
      fn()
    })
  }

  xhr.prototype.send = function (/* ...args */) {
    stackStart.forEach((fn) => {
      fn()
    })
    this.addEventListener('loadend', endHandler, false)
    this.addEventListener('error', errorHandler, false)
    send.apply(this, arguments as any)
  }
}

/**
 * restore a callback that will be called when start & end AJAX request
 * @param start
 * @param stop
 * @param error
 */
export function restoreAjax({start, stop, error}: Options) {
  stackStart.splice(stackStart.indexOf(start), 1)
  stackStop.splice(stackStop.indexOf(stop), 1)
  stackError.splice(stackStop.indexOf(error), 1)

  highJackCount = Math.max(0, highJackCount - 1)
  if(!highJackCount) {
    xhr.prototype.send = send
  }
}
